import { Modal } from 'antd';
import React, { CSSProperties } from 'react';

import { CloseOutlined } from '@ant-design/icons';

import styles from './index.module.css';

type Props = {
  children: React.ReactElement;
  isOpen: boolean;
  onClose: () => void;
  className?: string;
  style?: CSSProperties;
  title: React.ReactNode;
  closable?: boolean;
  zIndex?: number;
};

export const ModalComponentV1 = ({
  children,
  isOpen,
  onClose,
  title,
  closable,
  className,
  style,
  zIndex,
}: Props) => {
  return (
    <Modal
      title={title}
      open={isOpen}
      afterClose={onClose}
      onCancel={onClose}
      className={className ? `${className} ${styles.modal}` : styles.modal}
      footer={false}
      style={style}
      closable={closable}
      zIndex={zIndex}
      centered={true}
      closeIcon={
        <img
          src="/assets/svg/X.svg"
          alt="close button"
          width={19}
          height={19}
        />
      }
    >
      {children}
    </Modal>
  );
};
